import {useState} from 'react';

import { Slide } from 'react-awesome-reveal';

import { useApp } from '../app-context';
import { ChatService } from '../services/ChatService'
import { TSPage } from '../components/commons';

import './ThirdpartyPage.scss';

const ThirdpartyPage = function ({ name, onBack, data, btn }) {
    const [state, dispatcher] = useApp();
    const [stateDetails, setStateDetails] = useState({});
    const [stateErrors, setStateErrors] = useState({});
    const [stateBusy, setStateBusy] = useState(false);

    const handleBack = (e) => {
        if (stateBusy) return;

        if (onBack)
            onBack(true, e);
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (stateBusy) return;

        if (!validateFields()) {
            return;
        }

        let answer = {
            display: "התקבלו פרטי חשבון ביט",
            value: stateDetails,
            id: btn?.id,
            field: btn?.field
        }

        setStateBusy(true);
        ChatService.processAnswer(dispatcher, state, answer)
            .then(() => {
                dispatcher({ action: 'closeOverlay', params: 'thirdparty' });
            })
            .catch(ex => {
                alert(ex);
            }).finally(() => {
                setStateBusy(false);
            });
    };

    const validateFields = function () {
        var errors = {};
        if (!stateDetails.thirdpartyFullName)
            errors.thirdpartyFullName = "יש להזין שם פרטי ומשפחה";

        if (!stateDetails.thirdpartyPhone)
            errors.thirdpartyPhone = "יש להזין את מספר הטלפון";

        setStateErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const onFieldChange = function (id, e) {
        const cs = { ...stateDetails };
        cs[id] = e.target.value;
        setStateDetails(cs);
    }

    const cb = (_inview, ioe) => { ioe.target.querySelector(".container").classList.add("on"); }

    data = data || {};

    return (
        <TSPage name={name}>
            <Slide direction="up" duration="500" onVisibilityChange={cb}>
                <div className="container on">
                    <div className="header">
                        <button className="btn right" onClick={handleBack}>
                            <img src="img/right-arrow.svg" alt="back" />
                        </button>
                        <div className="title">
                            פרטי הצד הניזוק
                        </div>
                    </div>
                    <div className="content" style={{ marginLeft: -state?.uiParams?.scrollSize?.w + "px" }}>
                        <div className="top">
                            <form onSubmit={handleSubmit}>
                                <h5>כדי לטפל בתביעה, אנחנו צריכים את פרטי הצד הניזוק.</h5>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>שם מלא</label>
                                        <input type="text" name="thirdpartyFullName" value={stateDetails.thirdpartyFullName} onChange={onFieldChange.bind(this, "thirdpartyFullName")} className={stateErrors.thirdpartyFullName && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyFullName && "on")}>{stateErrors.thirdpartyFullName}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>מספר טלפון</label>
                                        <input type="tel" name="thirdpartyPhone" value={stateDetails.thirdpartyPhone} onChange={onFieldChange.bind(this, "thirdpartyPhone")} className={stateErrors.thirdpartyPhone && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyPhone && "on")}>{stateErrors.thirdpartyPhone}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>מספר ת"ז (אופציונלי)</label>
                                        <input type="number" name="thirdpartyPId" value={stateDetails.thirdpartyPId} onChange={onFieldChange.bind(this, "thirdpartyPId")} className={stateErrors.thirdpartyPId && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyPId && "on")}>{stateErrors.thirdpartyPId}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>דוא"ל (אופציונלי)</label>
                                        <input type="email" name="thirdpartyEmail" value={stateDetails.thirdpartyEmail} onChange={onFieldChange.bind(this, "thirdpartyEmail")} className={stateErrors.thirdpartyEmail && "error"} ></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyEmail && "on")}>{stateErrors.thirdpartyEmail}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>עיר (אופציונלי)</label>
                                        <input type="text" name="thirdpartyCity" value={stateDetails.thirdpartyCity} onChange={onFieldChange.bind(this, "thirdpartyCity")} className={stateErrors.thirdpartyCity && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyCity && "on")}>{stateErrors.thirdpartyCity}</div>
                                    </div>
                                </div>
                                <div className={"row"}>
                                    <div className="part single">
                                        <label>רחוב (אופציונלי)</label>
                                        <input type="email" name="thirdpartyStreet" value={stateDetails.thirdpartyStreet} onChange={onFieldChange.bind(this, "thirdpartyStreet")} className={stateErrors.thirdpartyStreet && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyStreet && "on")}>{stateErrors.thirdpartyStreet}</div>
                                    </div>
                                </div>
                                <div className={"row double"}>
                                    <div className="part">
                                        <label>מספר בית (אופציונלי)</label>
                                        <input type="number" name="thirdpartyHouse" value={stateDetails.thirdpartyHouse} onChange={onFieldChange.bind(this, "thirdpartyHouse")} className={stateErrors.thirdpartyHouse && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyHouse && "on")}>{stateErrors.thirdpartyHouse}</div>
                                    </div>
                                    <div className="part">
                                        <label>מיקוד (אופציונלי)</label>
                                        <input type="number" name="thirdpartyZipcode" value={stateDetails.thirdpartyZipcode} onChange={onFieldChange.bind(this, "thirdpartyZipcode")} className={stateErrors.thirdpartyZipcode && "error"}></input>
                                        <div className={"validationError " + (stateErrors.thirdpartyZipcode && "on")}>{stateErrors.thirdpartyZipcode}</div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="blueLine"></div>
                    <div className="dialog-buttons">
                        <button className="orange" onClick={handleSubmit}>אישור</button>
                        <button onClick={handleBack}>ביטול</button>
                    </div>
                </div>
            </Slide >
        </TSPage >
    );
}

export { ThirdpartyPage }